module.exports = __webpack_public_path__ + "static/img/customer3.c9bdcfab.png";